import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import Modal from 'react-bootstrap/lib/Modal';
import Col from 'react-bootstrap/lib/Col';
import { connect } from 'react-redux';
import { closeWishListModal } from '../../actions/WishList/modalActions';

import WishListModalForm from '../WishListModalForm';
import Loader from '../Loader';
import CreateWishList from './CreateWishList';
import { withQuery } from '../../hoc/withGraphql';

import messages from '../../locale/messages';
import getWishListGroupQuery from './getAllWishListGroup.graphql';
import ListingDataQuery from '../WishListModal/ListDetails/getListingData.graphql';

import closeIcon from '/public/SiteIcons/commonModalCloseBtn.svg';

import s from './WishListModal.css';
class WishListModal extends Component {
  static propTypes = {
    closeWishListModal: PropTypes.any,
    wishListModal: PropTypes.bool,
    formatMessage: PropTypes.any,
    data: PropTypes.shape({
      loading: PropTypes.bool,
      getAllWishListGroup: PropTypes.any
    }),
    getListingData: PropTypes.shape({
      loading: PropTypes.bool,
      UserListing: PropTypes.object
    }),
  };

  static defaultProps = {
    data: {
      loading: true
    },
  }

  constructor(props) {
    super(props);
    this.state = {
      wishListModalStatus: false,
      showImage: ''
    };
  }

  componentDidMount() {
    const { wishListModal, getListingData } = this.props;
    const UserListing = getListingData?.UserListing;
    if (wishListModal === true) {
      this.setState({ wishListModalStatus: true });
    }
    this.updateCoverImage(UserListing);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { wishListModal, getListingData } = nextProps;
    const UserListing = getListingData?.UserListing;
    if (wishListModal === true) {
      this.setState({ wishListModalStatus: true });
    } else {
      this.setState({ wishListModalStatus: false });
    }
    this.updateCoverImage(UserListing);
  }

  updateCoverImage(UserListing) {
    if (!UserListing) return;
    let coverPhoto = UserListing.coverPhoto;
    let coverImage = UserListing.listPhotos && UserListing.listPhotos.find(o => o.id == coverPhoto);
    let path = '/images/upload/x_large_';
    let showImage;
    if (coverImage) {
      showImage = path + coverImage.name;
      this.setState({ showImage: showImage })
    } else if (!coverImage && UserListing.listPhotos && UserListing.listPhotos.length > 0) {
      showImage = path + (UserListing.listPhotos && UserListing.listPhotos[0].name);
      this.setState({ showImage: showImage })
    }
  }

  render() {
    const { closeWishListModal, data, profileId, listId } = this.props;
    const { wishListModalStatus, showImage } = this.state;
    const loading = data?.loading ?? true;
    const getAllWishListGroup = data?.getAllWishListGroup;
    const queryError = data?.error;

    let wishListGroups = [];
    if (getAllWishListGroup?.count > 0) {
      getAllWishListGroup.wishListGroupData.map((option, index) => {
        if (option.wishListIds.indexOf(listId) !== -1) {
          wishListGroups.push(option.id);
        }
      });
    }

    let initialValues = {
      listId,
      wishListGroups
    };

    return (
      <div>
        <Modal show={wishListModalStatus} animation={false} onHide={closeWishListModal} dialogClassName={cx(s.logInModalContainer, s.wishlistModal)} >
          <div className={s.sectionBlock}>
            <Modal.Header>
              <div onClick={() => closeWishListModal()} className={s.closeBtn}><img src={closeIcon} /></div>
              <div className={cx(s.wishListTitle)}>
                <FormattedMessage {...messages.wishLists} />
              </div>
            </Modal.Header>
            <Modal.Body bsClass={s.logInModalBody}>
              <div className={s.root}>
                <div className={cx(s.container, 'rtlWishListInput')}>
                  <CreateWishList initialValues={initialValues} />
                  {
                    loading && <Col xs={12} sm={12} md={12} lg={12}>
                      <Loader type="text" />
                    </Col>
                  }
                  {
                    !loading && !queryError && <WishListModalForm data={data} initialValues={initialValues} />
                  }
                  {
                    !loading && queryError && <Col xs={12} sm={12} md={12} lg={12}>
                      <p className={s.errorMessage}><FormattedMessage {...messages.somethingWentWrong} /></p>
                    </Col>
                  }
                  {/* <div className={s.cancelSection}>
                    <a onClick={() => closeWishListModal()} className={s.cancelLink}>
                      <FormattedMessage {...messages.cancel} />
                    </a>
                  </div> */}
                </div>
              </div>
            </Modal.Body>
          </div>
        </Modal>
      </div>
    );
  }
}


const mapState = state => ({
  wishListModal: state.modalStatus.wishListModalOpen,
  profileId: state.account.data.profileId,
  listId: state.modalStatus.listId
});

const mapDispatch = {
  closeWishListModal
};

export default compose(
  injectIntl,
  withStyles(s),
  connect(mapState, mapDispatch),
  withQuery(getWishListGroupQuery,
    {
      options: (props) => ({
        variables: {
          profileId: props.profileId
        },
        skip: !props.profileId,
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  ),
  withQuery(ListingDataQuery,
    {
      name: 'getListingData',
      options: (props) => ({
        variables: {
          listId: Number(props.listId),
        },
        skip: !props.listId,
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  ),

)(WishListModal);
